import { DateTime } from "luxon";

export const formatDateTime = (dateTime: string) => {
	return DateTime.fromISO(dateTime).toLocal().toFormat("yyyy-MM-dd HH:mm:ss");
};
